import axios from "axios";
import { initializeApp, getApps } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";
import { getCookie } from "cookies-next";
import ENDPOINTS from "./lib/endpoints";
import { firebaseConfig, vapidKey } from "./firebase.config";

// ✅ Initialize Firebase App only once
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

// ✅ Messaging instance (browser only)
let messaging = null;

if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    } else {
      console.warn("❌ Firebase Messaging is not supported in this browser.");
    }
  });
}

/**
 * Request FCM token from browser and optionally store it in backend
 */
export const requestForToken = async () => {
  if (typeof window === "undefined" || !messaging) return;

  const accessToken = getCookie("access-token");
  const authPrefix = process.env.NEXT_PUBLIC_AUTH_PREFIX || "/";
  const apiUrl = process.env.NEXT_PUBLIC_API_URL;

  try {
    const swPath =
      authPrefix === "/"
        ? "/firebase-messaging-sw.js"
        : `${authPrefix}/firebase-messaging-sw.js`;

    const registration = await navigator.serviceWorker.register(swPath);
    // console.log("✅ Service worker registered:", swPath);

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("❌ Notification permission denied");
      return;
    }

    const currentToken = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      // console.log("✅ FCM Token:", currentToken);

      await axios.post(
        `${apiUrl}${ENDPOINTS.FCM_STORE_TOKEN}`,
        { token: currentToken, is_web: 1 },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
    } else {
      console.warn("⚠️ No FCM token returned");
    }
  } catch (err) {
    console.error("❌ Error getting FCM token:", err);
  }
};

/**
 * Listen continuously for foreground messages
 */
export const onMessageListener = (callback) => {
  if (typeof window !== "undefined" && messaging) {
    onMessage(messaging, callback);
  }
};

export { app };
